import { postData } from './request'
import { getAPIBaseURL } from './helpers'

const base = () => `${getAPIBaseURL()}/v1`

export const signup = async (payload) => {
  const role = payload.role === 'CENTER' ? 'center' : 'attendee'
  const url = `${base()}/auth/${role}/signup`
  const headers = { 'Content-Type': 'application/x-www-form-urlencoded' }
  
  // Convert payload to URLSearchParams format
  const params = new URLSearchParams()
  Object.keys(payload).forEach(key => {
    if (payload[key] !== undefined && payload[key] !== null && payload[key] !== '') {
      params.append(key, payload[key])
    }
  })
  
  const res = await postData(url, headers, params.toString())
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data?.data || res.result?.data?.message }
}

export const login = async (payload) => {
  const role = payload.role === 'CENTER' ? 'center' : 'attendee'
  const url = `${base()}/auth/${role}/login`
  const headers = { 'Content-Type': 'application/x-www-form-urlencoded' }
  
  console.log('[AUTH] Login attempt:', { email: payload.email, role })
  
  // Convert payload to URLSearchParams format
  const params = new URLSearchParams()
  Object.keys(payload).forEach(key => {
    if (payload[key] !== undefined && payload[key] !== null && payload[key] !== '') {
      params.append(key, payload[key])
    }
  })
  
  try {
    const res = await postData(url, headers, params.toString())
    
    if (res.error === '') {
      console.log('[AUTH] Login success - Response:', res.result)
      
      // Backend returns: { message: 'successful', data: user }
      // Axios wraps it: res.data = { message: 'successful', data: user }
      // So we access: res.result.data.data
      const user = res.result?.data?.data || res.result?.data
      
      console.log('[AUTH] User data received:', user)
      
      if (user) {
        // Ensure user object has all required fields
        const userToStore = {
          ...user,
          _id: user._id || user.id,
          id: user.id || user._id,
          role: user.role || payload.role
        }
        
        console.log('[AUTH] Saving user to localStorage:', userToStore)
        localStorage.setItem('user', JSON.stringify(userToStore))
        sessionStorage.setItem('active', '1')
        console.log('[AUTH] User saved successfully')
      } else {
        console.warn('[AUTH] No user data in response. Full response:', res.result)
      }
      
      return { status: res.result.status, data: user }
    } else {
      const errorMsg = res.result?.data?.data || res.result?.data?.message || 'Unknown error'
      console.error('[AUTH] Login error:', {
        status: res.result?.status,
        error: errorMsg,
        fullResponse: res.result
      })
      return { status: res.result?.status || 500, error: errorMsg }
    }
  } catch (error) {
    console.error('[AUTH] Login exception:', error)
    return { status: 500, error: error?.message || 'Login failed unexpectedly' }
  }
}

export const forgotPassword = async ({ email }) => {
  const url = `${base()}/users/forgot-password`
  const headers = { 'Content-Type': 'application/x-www-form-urlencoded' }
  
  const params = new URLSearchParams()
  params.append('email', email)
  
  const res = await postData(url, headers, params.toString())
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data?.data || res.result?.data?.message }
}

export const resetPassword = async ({ userId, token, newPassword }) => {
  const url = `${base()}/users/password-reset/${userId}/${token}`
  const headers = { 'Content-Type': 'application/x-www-form-urlencoded' }
  
  const params = new URLSearchParams()
  params.append('newPassword', newPassword)
  
  const res = await postData(url, headers, params.toString())
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data?.data || res.result?.data?.message }
}

